import { memo, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { ProductContext } from '../context';
import css from './index.module.scss';
import ltrim from '../../../utils/strings/ltrim';
import { displayFitRating } from '../utils';
import { getSizeVerbose } from '../../../config/constants-sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var parseDescription = function parseDescription(descriptionText) {
  if (!descriptionText) {
    return [];
  }

  var parts = descriptionText.split('\n');
  var list = [];
  parts.forEach(function (line) {
    if (line !== '') {
      list.push(ltrim(line, ['-', ' ']));
    }
  });
  return list;
};

var Text = function Text(_ref) {
  var initialDescription = _ref.description,
      title = _ref.title;

  var _useContext = useContext(ProductContext),
      colorway = _useContext.colorway,
      reviewCount = _useContext.reviewCount,
      fitRatingAvg = _useContext.fitRatingAvg;

  var models = (colorway === null || colorway === void 0 ? void 0 : colorway.colorwayModels) || [];
  var description = parseDescription(initialDescription);
  var getModelInfo = useCallback(function (model, size, idx, length) {
    var modelInfo = length > 1 ? " (model ".concat(idx + 1, ")") : '';
    return "".concat(model.name, " is ").concat(model.height, " and wears a Size ").concat(getSizeVerbose(size).toLowerCase()).concat(modelInfo);
  }, []);
  var fitRating = '';

  if (displayFitRating(colorway, reviewCount)) {
    var integer = Math.floor(fitRatingAvg);
    var float = fitRatingAvg % 1;
    var pastHalf = float > 0.5;
    var fitIndex = pastHalf ? integer + 1 : integer;
    var FIT_RATINGS = ['small', 'a bit small', 'true to size', 'a bit large', 'runs large'];
    fitRating = /*#__PURE__*/_jsxs(_Fragment, {
      children: ["Customers are saying it fits ".concat(FIT_RATINGS[fitIndex], "."), ' ', /*#__PURE__*/_jsx("a", {
        href: "#reviews",
        children: "View All Reviews"
      })]
    });
  }

  if (!fitRating && description.length === 0 && models.length === 0) {
    return false;
  }

  return /*#__PURE__*/_jsxs("div", {
    className: css.col,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.panelTitle,
      children: title
    }), /*#__PURE__*/_jsxs("ul", {
      children: [description.map(function (text, idx) {
        return /*#__PURE__*/_jsx("li", {
          children: text
        }, "description-".concat(idx));
      }), fitRating && /*#__PURE__*/_jsx("li", {
        children: fitRating
      }), models.map(function (_ref2, idx) {
        var id = _ref2.id,
            model = _ref2.model,
            size = _ref2.size;
        return /*#__PURE__*/_jsx("li", {
          children: getModelInfo(model, size, idx, models.length)
        }, id);
      })]
    })]
  });
};

Text.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string
};
export default /*#__PURE__*/memo(Text);